import { useCallback, useEffect, useState } from 'react';

import { IoIosArrowBack } from 'react-icons/io';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Layout } from '~/components';
import api from '~/services/api';

import { tableHead } from './constants';

import { Header, HeaderWrapper, HeaderLabel, Container, Table } from './styles';

type SymbologyData = {
  id: number;
  stimulus: string;
  symbology: string;
  application_in_method: string;
  example: string;
  created_at: string;
  updated_at: string;
};

function Symbology() {
  const { goBack } = useHistory();

  const [tableData, setTableData] = useState<SymbologyData[]>([]);

  const handleGetSymbologyData = useCallback(async () => {
    try {
      const { data } = await api.get('symbology', {
        params: {
          perpage: 9999,
        },
      });

      setTableData(data?.symbology?.data);
    } catch (error) {
      console.log('error:', error);
      toast.error('Houve um erro ao buscar os dados da simbologia');
    }
  }, []);

  useEffect(() => {
    handleGetSymbologyData();
  }, [handleGetSymbologyData]);

  return (
    <Layout title="I.LAB">
      <Header>
        <HeaderWrapper onClick={() => goBack()}>
          <IoIosArrowBack color="#FFDF22" size={24} />
          <HeaderLabel>Simbologia</HeaderLabel>
        </HeaderWrapper>
      </Header>

      <Container>
        <Table>
          <thead>
            <tr>
              {tableHead.map((headTitle) => (
                <th key={headTitle}>{headTitle}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {tableData.map((rowContent) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={`simbology-${rowContent?.id}`}>
                <td>{rowContent?.stimulus}</td>
                <td>{rowContent?.symbology}</td>
                <td>{rowContent?.application_in_method}</td>
                <td>{rowContent?.example}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
    </Layout>
  );
}

export default Symbology;
